<template>
  <div class="section-card">
    <label>{{ heading }}:</label>
    <div class="grid">
      <div class="grid-item" v-for="item in items" :key="item.id">
        <span>{{ item.item_value }}</span>
      </div>
    </div>
    <button class="secondary-btn-dark">EDIT {{ heading }}</button>
  </div>
</template>

<script>
import { saveSection, createSection, deleteSection } from "@/api/requests";

export default {
  name: 'GridEditor',

  props: {
    type: {
      type: String,
      required: true,
    },
    heading: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
  },

  data() {
    return {
      headingVal: '',
      bodyVal: '',
    };
  },

  mounted() {
    this.headingVal = this.heading;
    this.bodyVal = this.body;
  },

  methods: {
    discardChanges() {
      this.headingVal = this.heading;
      this.bodyVal = this.body;
    },

    saveClicked() {
      this.new ? this.createNew() : this.saveChanges();
    },

    createNew() {
      const payload = {
        heading: this.headingVal,
        body: this.bodyVal,
        doc_type: this.type,
      };
      createSection(payload).then(() => {
        this.$store.commit('content/updateNewSection', payload);
        this.$toasted.global.app_success({
          message: "Content has been updated."
        });
      }).catch(() => {
        this.$toasted.global.app_error({
          message: "Failed to update content."
        });
      });
    },

    saveChanges() {
      const payload = {
        heading: this.headingVal,
        body: this.bodyVal,
      };
      saveSection(this.id, payload).then(() => {
        this.$toasted.global.app_success({
          message: "Content has been updated."
        });
      }).catch(() => {
        this.$toasted.global.app_error({
          message: "Failed to update content."
        });
      });
    },

    deleteClicked() {
      this.new ? this.deleteNew() : this.deleteExisting();
    },

    deleteNew() {
      this.$store.commit('content/deleteNewSection');
      this.$toasted.global.app_success({
        message: "New section has been updated."
      });
    },

    deleteExisting() {
      this.$confirm(
        "Are you sure you want to delete this section?", 
        "DELETE SECTION").then(() => {
          deleteSection(this.id).then(() => {
            this.$store.commit('content/deleteSection', this.id);
            this.$toasted.global.app_success({
              message: "Section has been deleted."
            });
          });
        }).catch(() => {
          this.$toasted.global.app_error({
            message: "Failed to delete section."
          });
        });
    }
  },

  computed: {
    items() {
      return this.$store.state.content.sections[0].items || [];
    },
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.section-card {
  max-width: 400px;
  width: 100%;
  background: $sec0;
  margin: $spacing-base;
  display: flex;
  flex-direction: column;
  padding: $spacing-base;

  label {
    font-size: $font-size-base;
    font-weight: 500;
    color: $sec6;
    margin-bottom: $spacing-small;
  }

  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: $spacing-base;

    .grid-item {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #FFF;
      font-weight: bold;
      height: 100px;
      background: $dark;
    }
  }
}
</style>